import { z } from 'zod';
import { HttpErrorResponse } from '../common/validation-error';
import { QuestionType } from '../common/question';
/** Fetch one activity for preview, by mission and activity slug. */
export const GetPreviewActivityParams = z.object({
    missionSlug: z.string().min(1),
    activitySlug: z.string().min(1),
});
export const SerializedDate = z.string();
export const PreviewQuestion = z.object({
    id: z.number(),
    updated_at: SerializedDate,
    created_at: SerializedDate,
    type: QuestionType,
    text: z.string(),
    hints: z.array(z.string()).nullable(),
    exercise_id: z.number().nullable(),
    slug: z.string(),
    setup_sql: z.string().nullable(),
    answer_dql: z.string().nullable(),
    verification_sql: z.string().nullable(),
    index_in_exercise: z.number(),
    looker_link: z.string().nullable(),
    tableau_link: z.string().nullable(),
    google_sheets_link: z.string().nullable(),
    model_answer: z.string().nullable(),
    notes: z.string().nullable(),
    powerbi_csv: z.string().nullable(),
    initial_py: z.string().nullable(),
    output_regexes_py: z.array(z.string()).nullable(),
    input_regexes_py: z.array(z.string()).nullable(),
    inputs_examples_py: z.array(z.string()).nullable(),
    expect_error_py: z.boolean().nullable(),
    intro_lesson_text: z.string(),
    setup_py: z.string().nullable(),
    llm_initial_prompt: z.string().nullable(),
    multiple_choice_answers: z
        .object({
        correct_answer: z.string(),
        distractors: z.array(z.string()),
    })
        .nullable(),
    strict_text_answers: z.array(z.string()).nullable(),
    is_draft: z.boolean(),
    applied_project_id: z.number().nullable(),
});
/** The JSON shape returned by the preview handler after Date serialization. */
export const GetPreviewActivityResponse = z.object({
    id: z.number(),
    updated_at: SerializedDate,
    created_at: SerializedDate,
    is_core: z.boolean().nullable(),
    title: z.string(),
    summary: z.string().nullable(),
    external_url: z.string().nullable(),
    type: z.enum(['EXTERNAL', 'EXERCISE']),
    mission_id: z.number().nullable(),
    estimate_seconds: z.number(),
    index_in_mission: z.number(),
    exercise_id: z.number().nullable(),
    is_teams_only: z.boolean(),
    is_draft: z.boolean(),
    slug: z.string(),
    activity_session_id: z.null(),
    activity_session_instructor_review: z.null(),
    activity_session_instructor_score: z.null(),
    activity_session_instructor_question_comments: z.array(z.string()),
    latest_submission: z.null(),
    exercise: z.object({
        id: z.number(),
        updated_at: SerializedDate,
        created_at: SerializedDate,
        description: z.string(),
        lesson: z.string(),
        difficulty: z.number(),
        activity_id: z.number().nullable(),
        slug: z.string(),
        questions: z.array(PreviewQuestion),
    }),
    content_id: z.number(),
    content_slug: z.string(),
    content_title: z.string(),
    next_activity_slug: z.null(),
    next_mission_slug: z.null(),
});
export const getPreviewActivityRoute = {
    version: 1,
    method: 'GET',
    path: '/preview/missions/{missionSlug}/activities/{activitySlug}',
    name: 'get-activity-preview',
    request: { params: GetPreviewActivityParams },
    responses: {
        200: GetPreviewActivityResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
